import React from "react";
import { Badge } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import ToggleSwitch from "../../../Components/form_elements/toggle-switch";

const ContactTable = ({
    contacts,
    edit,
    remove,
    setPrimary,
    isEmergencyContactViewer = false,
    isViewingOtherEmployee = false
}) => {
    
    // Hide action buttons if EmergencyContactViewer is viewing another employee
    const showActionButtons = !(isEmergencyContactViewer && isViewingOtherEmployee);

    return (
<div className="contacts-read-only">
                    <div className="row d-none d-xl-flex title">
                        <div className="col col-12 col-xl-1 d-flex align-items-end">
                            <p className="w-100">Primary</p>
                        </div>
                        <div className="col col-12 col-xl-2 d-flex align-items-end">
                            <p className="w-100">Name</p>
                        </div>
                        <div className="col col-12 col-xl-2 d-flex align-items-end">
                            <p className="w-100">Phone Number</p>
                        </div>
                        <div className="col col-12 col-xl-2 d-flex align-items-end">
                            <p className="w-100">Relationship</p>
                        </div>
                        <div className="col col-12 col-xl-4 d-flex d-xl-flex">
                            <p className="w-100">Address</p>
                        </div>
                        {showActionButtons && (
                            <div className="col col-12 col-xl-1"></div>
                        )}
                    </div>
                    {contacts?.map((item, idx) => (
                        <div
                            key={`contact-${idx}`}
                            className="row data mb-3 mb-xl-0 "
                        >
                            <div className="col col-12 col-xl-1 d-none d-xl-flex">
                                {item.isPrimary ? (
                                    <div className="d-flex align-items-center" title="Primary contact">
                                        <Icon.CheckSquare className="icon text-success" />
                                    </div>
                                ) : (
                                    showActionButtons && (
                                        <button
                                            type="button"
                                            className="btn p-0 cds-text-small"
                                            style={{background:'none',border:'none',color:'#000',textDecoration:'underline'}}
                                            onClick={() => setPrimary && setPrimary(item)}
                                        >
                                            Make Primary
                                        </button>
                                    )
                                )}
                            </div>
                            <div className="col col-12 col-xl-2 d-none d-xl-flex">
                                <p>{item.firstName + ' ' + item.lastName}</p>
                            </div>
                            <div className="col col-12 col-xl-2 d-block d-xl-none pt-2">
                                <p className="cds-text-heavy mb-1">
                                    {item.firstName + ' ' + item.lastName}
                                    { item.isPrimary ?
                                        <Badge className='ms-2 badge bg-brand'>Primary</Badge> : <></>
                                    }
                                </p>
                                {!item.isPrimary && showActionButtons && (
                                    <button
                                        type="button"
                                        className="btn p-0 cds-text-small"
                                        style={{background:'none',border:'none',color:'#000',textDecoration:'underline'}}
                                        onClick={() => setPrimary && setPrimary(item)}
                                    >
                                        Make Primary
                                    </button>
                                )}
                            </div>
                            <div className="col col-12 col-xl-2 d-block d-xl-flex">
                                <p>{`(${item.areaCode}) ${item.phoneNumber}`}</p>
                            </div>
                            <div className="col col-12 col-xl-2 d-flex d-xl-flex">
                                <p>{item.relationship}</p>
                            </div>
                            <div className="col col-12 col-xl-4 d-flex d-xl-flex">
                                <div>
                                    <p>
                                        {
                                            item.addressLine1 + ' ' + item.addressLine2 + ", " + (item?.city !== ' ' ? item?.city + ', ' : '') + item?.state + ' ' + item?.postalCode + ' ' + item?.country
                                        }
                                    </p>
                                </div>
                            </div>
                            {showActionButtons && (
                                <div className="col col-12 col-xl-1 pt-1 text-start text-xl-end pb-2 pb-xl-0 controls">
                                    <Icon.PencilFill
                                        className="icon"
                                        key={`editPencil-${idx}`}
                                        onClick={() => edit(item)}
                                        role="button"
                                    />
                                    <span
                                        className="d-inline d-xl-none"
                                        onClick={() => edit(item)}
                                    >
                                        {" "}
                                        Edit
                                    </span>
                                    <Icon.TrashFill
                                        className="ms-3 icon"
                                        key={`editTrash-${idx}`}
                                        onClick={() => remove(item)}
                                        role="button"
                                    />
                                    <span
                                        className="d-inline d-xl-none"
                                        onClick={() => remove(item)}
                                    >
                                        {" "}
                                        Delete
                                    </span>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
    );
};

export default ContactTable;
